import {Communication} from "types/communication"

/**
 * Department chats must not auto mark-as-read on open for staff visitors
 * (anyone who is not the department student). Aligns with chat-api
 * `visitorIsStaff = departmentRoom.userId !== userId` so dual Staff+Student
 * users on a Student profile do not clear staff unread on open (V3-10522).
 *
 * When the department student id is unknown, do not treat the opener as a
 * staff visitor — keep the previous auto-mark behavior.
 */
export const shouldAutoMarkDepartmentChatAsReadOnOpen = (params: {
    roomType?: Communication.RoomTypes
    currentUserId?: number | null
    departmentStudentUserId?: number | null
}): boolean => {
    if (params.roomType !== Communication.RoomTypes.Department) {
        return true
    }
    if (
        params.departmentStudentUserId != null &&
        params.currentUserId != null &&
        params.currentUserId !== params.departmentStudentUserId
    ) {
        return false
    }
    return true
}
